/**
 * Environment variable helper
 * Supports both Vite (import.meta.env) and Node.js (process.env)
 */

export function getEnv(key: string, fallback?: string): string | undefined {
  // In browser/Vite, use import.meta.env
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key] || fallback;
  }
  // In Node.js, use process.env
  return process.env[key] || fallback;
}

// Convenience exports for common env vars
// IMPORTANT: These must be set in .env.local for extension builds
export const SUPABASE_URL = getEnv('VITE_SUPABASE_URL') || 'https://mhkibunsnofqrktyzcew.supabase.co';
export const SUPABASE_ANON_KEY = getEnv('VITE_SUPABASE_ANON_KEY') || 'sb_publishable_DzBkZSPZqfa_ErZI9rlVXQ_OHqzr63I';
export const OPENAI_API_KEY = getEnv('VITE_OPENAI_API_KEY');
export const CLAUDE_API_KEY = getEnv('VITE_CLAUDE_API_KEY');
